/* @ngInject */
function MiaLayoutController ($scope) {
  $scope.backgroundUrl = '/assets/img/backgrounds/mia-background.png'
  $scope.customerLogoPath = '/assets/img/logos/mia-animation.webm'
}

export { MiaLayoutController }
